import styled from 'styled-components';
import { AlignCenter, FlexBetween } from '../../../global/commonStyle';

const Main = styled.div`
  display: flex;
  gap: var(--space-16);
  .loading-animation {
    overflow: hidden;
  }
  .loading-animation::before {
    content: '';
    display: block;
    height: 100%;
    width: 100%;
    animation: loading 1s infinite;
    background: linear-gradient(to right, transparent, var(--background-tertiary), transparent);
  }

  @keyframes loading {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }
`;
const First = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
  width: 320px;
  .second {
    width: 47px;
  }
  .third {
    width: 81px;
  }
`;

const Top = styled.div`
  ${FlexBetween}
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
`;

const Left = styled.div`
  width: 96px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background: var(--background-muted);
`;
const Right = styled.div`
  width: 18px;
  height: 18px;
  border-radius: var(--border-radius-6);
  background-color: var(--background-muted);
`;

const Card = styled.div`
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  padding: var(--space-12);
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
`;

const Row1 = styled.div`
  ${AlignCenter}
  gap: var(--space-10);
`;

const Row2 = styled.div`
  display: flex;
  padding-left: var(--space-32);
`;

const Row3 = styled.div`
  padding-left: var(--space-24);
`;

const LeftRow = styled.div`
  width: 14px;
  height: 14px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;
const RightRow = styled.div`
  width: 272px;
  height: 12px;
  border-radius: var(--border-radius-full);
  background-color: var(--background-muted);
`;
const Circle = styled.div`
  width: 28px;
  height: 28px;
  border-radius: var(--border-radius-full);
  border: 3px solid var(--background-primary);
  background: var(--background-muted);
  margin-left: -12px;
`;
export { Main, First, Top, Bottom, Left, Right, Card, Row1, Row2, Row3, LeftRow, RightRow, Circle };
